import styled from 'styled-components';

export const Wrapper = styled.div`
  bottom: 0;
  display: block;
  flex: auto;
  height: 100%;
  margin: 15px;
  max-height: 20px;
  max-width: 20px;
  position: absolute;
  right: 0;
  width: 100%;
`;
